<template>
   <div>
     <p>123</p>
   </div>
</template>

<script>
export default {
  name: 'PublicTest'
}
</script>

<style scoped>

</style>
